import { useEffect } from "react";
import { ProductTableRow } from "./ProductTableRow";
import { TableTag } from "./TableStyles";
import { useProductListData } from "./useProductListData";

const ProductListInWorkspaceSingle = (props) => {
  const { portfolios, workspaceId, setRendered, amData } = props;

  const {
    productList,
    ports,
    sortedPortNames,
    ready,
    getAssetName,
  } = useProductListData(workspaceId, portfolios, amData);

  useEffect(() => {
    if (ready && setRendered) {
      setRendered(true);
    }
  }, [ready, setRendered]);

  if (!productList || !ports) return <></>;

  return (
    <div
      style={{
        width: 57 + 398 + 50 + 70 + 57 * ports.length,
        minHeight: 24 * (productList.length + 1) + 40,
      }}
    >
      <TableTag>
        <thead>
          <tr>
            <th>資産型</th>
            <th>運用プロダクト</th>
            <th>期待収益率</th>
            <th>標準偏差</th>
            {sortedPortNames.map((port) => (
              <th key={port}>{port}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {productList.map((product) => (
            <ProductTableRow
              key={`${product.asset}-${product.id}`}
              product={product}
              sortedPortNames={sortedPortNames}
              getAssetName={getAssetName}
            />
          ))}
        </tbody>
      </TableTag>
    </div>
  );
};

export { ProductListInWorkspaceSingle };
